WiseMetering.Views.IndexOrganizationNewSites = WiseMetering.Views.TableIndex.extend({
    icon: 'sites',
    name: function() {
        return i18next.t('glossary.sites');
    },

    createTable: function() {
        this.collection = WiseMetering.zones.newSites();

        this.table = new WiseMetering.Views.Table({
            aLengthMenu: [25, 50, 100],
            collection: this.collection,
            columns: this.getColumns(),
            id: 'sites',
            modelSerializer: function(model) {
                let json = {};

                const
                    sitePackage = WiseMetering.sitePackages.findWhere({ site_id: model.id }),
                    pack = sitePackage ? WiseMetering.packages.get(sitePackage.get('package_id')) : null;

                json.id = model.id;
                json.name = model.get('name');
                json.packageName = pack ? pack.get('name') : '-';
                json.wise_boxes_default_limit = pack ? pack.get('wise_boxes') : '-';
                json.wise_boxes_extra_limit = pack ? sitePackage.get('wise_boxes_extra_limit') : '-';
                json.wise_boxes_used = pack ? sitePackage.getUsed('wise_boxes') : this.getEmpty();
                json.devices_default_limit = pack ? pack.get('devices') : '-';
                json.devices_extra_limit = pack ? sitePackage.get('devices_extra_limit') : '-';
                json.devices_used = pack ? sitePackage.getUsed('devices') : this.getEmpty();
                json.output_default_limit = pack ? pack.defaultOutputs() : '-';
                json.output_used = pack ? sitePackage.getUsed('control_outputs') : this.getEmpty();
                json.current_sensor_default_limit = pack ? pack.defaultCurrentSensors() : '-';
                json.current_sensor_used = pack ? sitePackage.getUsed('current_sensors') : this.getEmpty();

                return json;
            }.bind(this),
            toolbar_actions: {
                show: {
                    view_call: model => new WiseMetering.Views.ZoneEdit({ model, title: `Edit ${model.get('name')}` })
                },
                new: {
                    permission: 'superuser',
                    view_call: () => {
                        const model = new WiseMetering.Model.Zone({ tag_ids: [] });
                        new WiseMetering.Views.NewSite({ collection: WiseMetering.zones, model });
                    }
                },
                edit: {
                    view_call: model => new WiseMetering.Views.ZoneEdit({ model, title: `Edit ${model.get('name')}` })
                },
                manage_package: {
                    permission: 'superuser',
                    icon: 'package',
                    label: i18next.t('sites.manage_package'),
                    view_call: site => new WiseMetering.Views.SitePackageEdit({
                        model: site,
                        title: 'Edit site package'
                    })
                },
                activate: {
                    permission: 'superuser',
                    icon: 'play',
                    label: i18next.t('sites.activate_site'),
                    view_call: function(site) {
                        new WiseMetering.Views.ActivateSite({ collection: WiseMetering.zones.newSites(), model: site });
                    }.bind(this)
                },
                delete: {
                    permission: 'manager'
                }
            }
        });
        $(this.body.el).html(this.table.el);
    },

    getColumns: function() {
        if (WiseMetering.currentOrganization.showControlOutputs()) {
            return Object.assign(this.getDefaultColumns(), this.getRetailColumns());
        } else {
            return this.getDefaultColumns();
        }
    },

    getDefaultColumns: function() {
        return {
            name: i18next.t('common.name'),
            packageName: {
                title: i18next.t('sites.package_name'),
                mRender: function(packageName) {
                    return `<div style="text-transform: capitalize">${packageName}</div>`;
                }
            },
            wise_boxes_default_limit: {
                title: i18next.t('sites.wise_boxes_limit'),
                className: 'align-right'
            },
            wise_boxes_extra_limit: {
                title: i18next.t('sites.extra_wise_boxes_limit'),
                className: 'align-right'
            },
            wise_boxes_used: {
                title: i18next.t('sites.used_wise_boxes'),
                className: 'align-right',
                mRender: function({ value, deviation, color }) {
                    return deviation === 100 ? value : this.usedEl(value, deviation, color);
                }.bind(this)
            },
            devices_default_limit: {
                title: i18next.t('sites.devices_limit'),
                className: 'align-right'
            },
            devices_extra_limit: {
                title: i18next.t('sites.extra_devices_limit'),
                className: 'align-right'
            },
            devices_used: {
                title: i18next.t('sites.used_devices'),
                className: 'align-right',
                mRender: function({ value, deviation, color }) {
                    return deviation === 100 ? value : this.usedEl(value, deviation, color, 30);
                }.bind(this)
            }
        };
    },

    getRetailColumns: function() {
        return {
            output_default_limit: {
                title: i18next.t('sites.control_outputs_limit'),
                className: 'align-right'
            },
            output_used: {
                title: i18next.t('sites.used_control_outputs'),
                className: 'align-right',
                mRender: function({ value, deviation, color }) {
                    return deviation === 100 ? value : this.usedEl(value, deviation, color);
                }.bind(this)
            },
            current_sensor_default_limit: {
                title: i18next.t('sites.current_sensors_limit'),
                className: 'align-right'
            },
            current_sensor_used: {
                title: i18next.t('sites.used_current_sensors'),
                className: 'align-right',
                mRender: function({ value, deviation, color }) {
                    return deviation === 100 ? value : this.usedEl(value, deviation, color);
                }.bind(this)
            }
        };
    },

    getEmpty: function() {
        return {
            value: 0,
            deviation: 0.0,
            color: WiseMetering.Colors.lightGrey
        };
    },

    onClose: function() {
        this.stopListening(WiseMetering.zones);
        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.zones, 'add change', this.createTable.bind(this));
        this.createTable();
    },

    usedEl: function(value, deviation, color, width = 15) {
        return `
            <b style="font-size:8px;color:${color}">(${Number(deviation).toFixed(1)}%)</b>
            <div style="display:inline-block;width:${width}px">${value}</div>
        `;
    }
});
